import React from 'react'
import GazetteAnnouncements from './GazetteAnnouncements'
import MvNews from './MvNews'
import IconButton from '@/components/actionButtons/IconButton'
import { useMyDialog } from '@/context/MyDialogProvider'

const ScraperPage = () => {
  const {open} = useMyDialog()
  return (
    <div>
        <div className="flex flex-wrap gap-2">

          <IconButton 
            label="Gazette Announcements"
            to="/mviulaan" />
          <IconButton 
            label="Mv News"
            to="/mvnews" />
          <IconButton 
            label="Mv Stocks"
            to="/mvstocks" />
             
      
      
        </div>
    </div>
  )
}

export default ScraperPage
